import {
  getAuth,
  signInWithPopup,
  FacebookAuthProvider,
  UserCredential,
  browserLocalPersistence,
} from 'firebase/auth';

export async function facebookAuth(): Promise<UserCredential> {
  const auth = getAuth();
  const provider = new FacebookAuthProvider();

  return auth.setPersistence(browserLocalPersistence).then(() => {
    return signInWithPopup(auth, provider);
  });
}
